import { createContext, useContext, useMemo } from "react";
import { IHolidayTypeService } from "../services/HolidayTypeService";
import { useHttpRequestService } from "./HttpRequestContext";
import { createHolidayTypeService } from "./Bootstrap";

const HolidayTypeContext = createContext<IHolidayTypeService | null>(null);

export const HolidayTypeProvider: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
    const httpRequestService = useHttpRequestService();
    const holidayTypeService = useMemo(() => createHolidayTypeService(httpRequestService), [httpRequestService]);
    return (
        <HolidayTypeContext.Provider value={holidayTypeService}>
            {children}
        </HolidayTypeContext.Provider>
    );
}

export const useHolidayTypeService = () => {
    const holidayTypeService = useContext(HolidayTypeContext);
    if (!holidayTypeService) {
        throw new Error('useHolidayTypeService must be used within a HolidayTypeProvider');
    }
    return holidayTypeService;
}; 
